import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const useStyles = makeStyles((theme: Theme) => ({
  actions: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    gap: '0.5rem',
    paddingTop: '1.5rem',
  },

  submitButton: {
    height: '2.25rem !important',
    padding: '1rem 1.5rem !important',
  },

  cancelButton: {
    height: '2.25rem !important',
    padding: '1rem !important',
    color: '#BA1A1A !important',
    border: `1px solid ${getRGBA('#BA1A1A', 0.5)} !important`,
  },
}))

export { useStyles }
